<template>
  <section class=" px-m 1xl:p-55px ">
    <div
          @click="$router.go(-1)"
          class="blue-font cursor-pointer my-3 d-flex align-items-center text-skin-description"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style="max-width:17px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
          <span class="ml-2">volver</span>
        </div>
    <form @submit.prevent="handleForm" action="" autocomplete="off">
      <p class="font-semibold	text-l text-skin-secondary">Mi cuenta</p>
      <div
        class="grid grid-cols-1 1xl:grid-cols-2fr 1xl:gap-y-20 1xl:gap-x-36 p-m"
      >
        <CustomInput
          label="Nombres"
          ref="names"
          identity="Nombres"
          placeholder="Nombres"
          v-model="user.name"
          :rules="{
            required: true,
            alpha: true,
          }"
        />

        <CustomInput
          label="Apellidos"
          ref="lnames"
          identity="Apellidos"
          placeholder="Apellidos"
          v-model="user.lnames"
          :rules="{
            required: true,
            alpha: true,
          }"
        />

        <CustomInput
          label="Fecha de nacimiento"
          ref="birthday"
          identity="Fecha de nacimiento"
          placeholder="Fecha de nacimiento"
          v-model="user.birthday"
          class="cursor-pointer"
          type="date"
          :rules="{
            required: true,
          }"
        />

        <CustomInput
          identity="email"
          ref="email"
          label="Correo electrónico"
          placeholder="Correo electrónico"
          v-model="user.email"
          :rules="{
            required: true,
            email: true,
          }"
        />

        <CustomInput
          identity="phone"
          ref="phone"
          label="Número de celular"
          placeholder="Número de celular"
          v-model="user.phone"
          :rules="{
            numeric: true,
          }"
        />

        <CustomInput
          identity="id"
          ref="id"
          label="Número de identificación"
          placeholder="Número de identificación"
          v-model="user.id_number"
          :rules="{
            numeric: true,
          }"
        />
      </div>

      <p class="font-semibold	 text-l text-skin-secondary">Privacidad</p>
      <div class="grid grid-cols-1fr gap-y-20 p-m">
        <CustomInput
          :password="true"
          v-model="user.password"
          :type="type1"
          @changeType="changeType1"
          ref="password"
          identity="Contraseña"
          placeholder="Ingresa tu contraseña actual"
          label="Contraseña"
        />
        <CustomInput
          :password="true"
          :type="type2"
          @changeType="changeType2"
          ref="newpassword"
          placeholder="Ingresa tu nueva contraseña"
          label="Nueva Contraseña"
          identity="Nueva Contraseña"
          v-model="user.newpassword"
          :rules="{
            required: true,
            alphaNum: true,
            minLength: 8,
          }"
        />
        <CustomInput
          :password="true"
          @changeType="changeType3"
          :type="type3"
          placeholder="Repite tu nueva contraseña"
          label="Repetir nueva contraseña"
          identity="Repetir nueva contraseña"
          v-model="user.repeatnewpassword"
          ref="repeatnewpassword"
          :rules="{
            required: true,
          }"
        />
      </div>

      <Button
        text_color="white"
        class="mx-auto md:mx-25"
        text="Guardar cambios"
        @click="validate"
      />
    </form>
  </section>
</template>

<script>
import Button from "./Button.vue";
import CustomInput from "./CustomInput.vue";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
    CustomInput,
    Button,
  },
  data() {
    return {
      type1: 'password',
      type2: 'password',
      type3: 'password',
      user: {
        name: "",
        lnames: "",
        birthday: "",
        email: "",
        password: "",
        newpassword: null,
        phone: "",
        repeatnewpassword: null,
        id_number: "",
      },
    };
  },
  methods: {
    changeType1(val){
      this.type1 = val
    },
    changeType2(val){
      this.type2 = val
    },
    changeType3(val){
      this.type3 = val
    },
    async handleForm() {
      if (!this.validate()) return;

      let updateUser = {
        id: this.GET_USER.user_id,
        name: this.user.name,
        last_name: this.user.lnames,
        document: this.user.id_number,
        phone: this.user.phone,
        movil: "",
        birthday: this.user.birthday,
        sex: "",
      };

      let updatePassword = {
        password: this.user.newpassword,
        oldPassword: this.user.password,
      };

      if (this.user.newpassword) {
        this.$store.dispatch("updatePassword/updatePassword", updatePassword);
      }

      this.$store.dispatch("updateUser/update_user", updateUser);

      if (this.GET_USERIMAGE) {
        var url = "/api/v2/userImage";

        axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("a_t")}`;

        const config = {
          headers: {
            "content-type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("a_t")}`,
          },
        };
        axios.post(url, this.GET_USERIMAGE, config).then(() => {});
      }

      this.$store.commit("updateUser/SET_USER", updateUser);
    },

    validate() {
      if (this.$refs.email.validate()) {
        return false;
      }

      if (this.$refs.names.validate()) {
        return false;
      }

      if (this.$refs.lnames.validate()) {
        return false;
      }

      if (this.$refs.birthday.validate()) {
        return false;
      }

      if (this.$refs.password.validate()) {
        return false;
      }

      if (this.$refs.phone.validate()) {
        return false;
      }

      if (this.$refs.id.validate()) {
        return false;
      }

      if (this.user.password.length) {
        if (this.$refs.newpassword.validate()) {
          return false;
        }

        if (this.$refs.repeatnewpassword.validate()) {
          return false;
        }
      }

      return true;
    },
  },
  computed: {
    ...mapGetters("getUser", ["GET_USER"]),
    ...mapGetters("userImageProfile", ["GET_USERIMAGE"]),
  },
  mounted() {
    this.user.name = this.GET_USER.people_first_name;
    this.user.lnames = this.GET_USER.people_surnames;
    this.user.birthday = this.GET_USER.people_birthday;
    this.user.id_number = this.GET_USER.people_document;
    this.user.email = this.GET_USER.email;
    this.user.phone = this.GET_USER.people_phone;
  },
};
</script>

<style></style>
